'use strict';

/**
 * hpe sticky top
 * used for fixing things to top of viewport, pass it an array of targets to apply, each with
 * an html element and a classname to apply when item should be sticky
 */

const { debounce } = require('@exadel/esl/modules/esl-utils/async');
const { PrivacyBannerProxy } = require('core/hpe-privacy-banner');

module.exports = (function () {

    var targets = []; //list of targets
    var isScrollTick = false; //used to throttle rAF calls

    /**
     * enable sticky nav scrolling behavior
     * @param {array} targetList required list of elements to initialize
     */
    function initialize(targetList) {
        if (targetList) {

            //initialize each item in target list with starting values
            targets = targetList.map(function(item) {

                //required props:
                //measureElement: non-positioned element on page to measure when it moves out of top of viewport
                //stickyElement: element to add or remove fixed class to
                //offsetValue: additional value used in calcs (height of stickyElement) or zero
                //className: the name of the class to add/remove to stickyElement
                return {
                    measureElement: item.measureElement,
                    stickyElement: item.stickyElement,
                    offsetValue: item.offsetValue || 0,
                    className: item.className,
                    isLocked: false,
                    offsetTop: 0
                };
            });

            //set initial positions
            updatePosition();

            //event handlers
            window.addEventListener('scroll', requestScrollTick);
            window.addEventListener('resize', debounce(updatePosition, 300));
            PrivacyBannerProxy.instance.addEventListener('change', updatePosition.bind(this));
        }
    }

    /**
     * throttle requests to requestanimationframe
     */
    function requestScrollTick() {
        if (!isScrollTick) {
            window.requestAnimationFrame(updatePosition);
        }
        isScrollTick = true;
    }

    /**
     * handle scroll events to determine to add or remove fixed class names
     */
    function updatePosition() {

        var target, i;

        for (i = 0; i < targets.length; i++) {

            target = targets[i];

            target.offsetTop = target.measureElement.getBoundingClientRect().top;

            if ((!target.isLocked) && (target.offsetTop < target.offsetValue)) {
                target.stickyElement.classList.add(target.className);
                target.isLocked = true;
            } else if (target.isLocked && (target.offsetTop >= 0)) {
                target.stickyElement.classList.remove(target.className);
                target.isLocked = false;
            }
        }

        isScrollTick = false;
    }

    //public methods, objects
    return {
        initialize: initialize
    };

})();
